import React from "react";
import styled from "styled-components";

import Input from "./Input";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const CurrencySign = styled.div`
  flex: none;
  margin-right: 10px;

  font-size: var(--textL);
  font-weight: 500;
  color: var(--husk);
`;

const MoneyInput = (props) => (
  <Container>
    <CurrencySign>£</CurrencySign>
    <Input
      id={props.id || undefined}
      step="0.01"
      type="number"
      placeholder="0.00"
      onKeyPress={(event) => {
        // Users can only enter numbers, ".", "-" and "+".
        // If any other character is entered then the field will no-op.
        const validCharRegex = /[0-9.+-]+/;
        if (!validCharRegex.test(event.key)) {
          event.preventDefault();
        }
      }}
      {...props} // can override the attributes above, like placeholder
      {...props?.field}
    />
  </Container>
);

export default MoneyInput;
